import CodeExamplesPage from '../../mdx/resources/code-examples.mdx'
import SupportPage from '../../mdx/resources/support.mdx'
import ApiExplorerPage from '../../mdx/resources/api-explorer.mdx'
import DividerLine from '../shared/divider-line'
import Anchor from '../anchor'
import React, { Fragment } from 'react'
import DocsPageGlobalStyles from '../../styles/docs-page'

const DocsSection = ({ children, anchorId, dividerLine = true }) => {
    return (
        <section>
            {dividerLine ? <DividerLine /> : ''}
            <Anchor id={anchorId} />
            {children}
        </section>
    )
}

const Resource = () => {
    return (
        <Fragment>
            <DocsPageGlobalStyles />
            <div>
                <DocsSection anchorId="code-examples" dividerLine={false}>
                    <CodeExamplesPage />
                </DocsSection>
                <DocsSection anchorId="support">
                    <SupportPage />
                </DocsSection>
                <DocsSection>
                    <ApiExplorerPage anchorId="api-explorer" />
                </DocsSection>
            </div>
        </Fragment>
    )
}

export default Resource
